import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDocumentField } from "../DefaultDocumentFields/redux/actions";
import { fetchDocStatuses } from "../DocumentStatuses/redux/actions";
import { fetchAllTemplates } from "../DocumentsTypesManager/redux/actions";
import { fetchRevisionStatuses } from "../RevisionStatuses/redux/actions";
import GraphSection from "./graphSection";
import ActivityTable from "./tableSection";

const IMS = () => {
  const [docTypeCheckList, setDocTypeCheckList] = useState([]);
  const [docTypeOptions, setDocTypeOptions] = useState([]);
  const [statusCheckList, setStatusCheckList] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  const { allTemplates } = useSelector((state) => state.docTypesReducer);
  const { allDocStatuses } = useSelector((state) => state.docStatusReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    let search = { template_type: "ims" };
    dispatch(fetchAllTemplates({ search, per_page: "all" }));
    dispatch(fetchDocStatuses());
    dispatch(fetchDocumentField());
    dispatch(fetchRevisionStatuses());
  }, []);

  useEffect(() => {
    let docOptions = allTemplates.map((el) => {
      const { name, id } = el;
      return { value: id, label: name };
    });
    setDocTypeOptions(docOptions);
  }, [allTemplates]);

  useEffect(() => {
    let statusOptions = allDocStatuses.map((el) => {
      const { status_name, id } = el;
      return { value: id, label: status_name };
    });
    setStatusOptions(statusOptions);
  }, [allDocStatuses]);

  return (
    <div className="page-top-div">
      <span
        className="text-span"
        style={{
          lineHeight: "17px",
        }}
      >
        DOCUMENT CONTROL - IMS
      </span>
      <GraphSection />
      <ActivityTable
        docTypeCheckList={docTypeCheckList}
        setDocTypeCheckList={setDocTypeCheckList}
        docTypeOptions={docTypeOptions}
        statusCheckList={statusCheckList}
        setStatusCheckList={setStatusCheckList}
        statusOptions={statusOptions}
      />
    </div>
  );
};

export default IMS;
